import { render, staticRenderFns } from "./AddonCard.vue?vue&type=template&id=492fa2d1&scoped=true"
import script from "./AddonCard.vue?vue&type=script&lang=js"
export * from "./AddonCard.vue?vue&type=script&lang=js"
import style0 from "./AddonCard.vue?vue&type=style&index=0&id=492fa2d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492fa2d1",
  null
  
)

export default component.exports